import React from "react";
import { FieldError, UseFormRegister } from "react-hook-form";

interface FormInputProps {
  label: string;
  name: string;
  register: ReturnType<UseFormRegister<any>>;
  error?: FieldError;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  rows?: number;
}

const FormTextarea: React.FC<FormInputProps> = ({
  label,
  name,
  register,
  error,
  className = "",
  required,
  disabled,
  rows
}) => {
  return (
    <div className={`${className}`}>
      <label className="block text-sm font-medium mb-1 text-gray-700" htmlFor={name}>{label} {required && <span className="text-red-500">*</span>}</label>
      <textarea
        id={name}
        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
        {...register}
        rows={rows}
        disabled={disabled}
      />
      {error && (
        <span className="text-red-500 text-xs mt-1 block">{error.message as string}</span>
      )}
    </div>
  );
};

export default FormTextarea;
